import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent implements OnInit {

  step: number;

  constructor(private store: Store<any>) {
    store.subscribe(store =>{
      this.step = store.mainCampaign.step;
    })
   }

  ngOnInit() {
  }

}
